<template>
  <div>
    <div class="flex items-center justify-between gap-4">
      <span class="flex grow flex-col">
        <span :id="`${id}-label`" class="text-sm/6 font-medium text-gray-900 dark:text-white">
          {{ label }}
        </span>
        <span :id="`${id}-desc`" class="text-sm text-gray-500 dark:text-gray-400">
          {{ description }}
        </span>
      </span>
      <button
        :id="id"
        type="button"
        role="switch"
        :aria-checked="modelValue"
        :aria-labelledby="`${id}-label`"
        :aria-describedby="describedBy"
        :disabled="disabled"
        class="relative inline-flex h-6 w-11 shrink-0 rounded-full p-0.5 outline-offset-2 outline-indigo-600 transition-colors duration-200 ease-in-out focus-visible:outline-2 disabled:cursor-not-allowed disabled:opacity-50 dark:outline-indigo-500"
        :class="modelValue ? 'bg-indigo-600 dark:bg-indigo-500' : 'bg-gray-200 dark:bg-white/10'"
        @click="emit('update:modelValue', !modelValue)"
      >
        <span
          aria-hidden="true"
          class="size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out"
          :class="modelValue ? 'translate-x-5' : 'translate-x-0'"
        />
      </button>
    </div>
    <div
      v-if="warning"
      :id="`${id}-warning`"
      class="mt-3 flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-800 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-300"
      role="alert"
    >
      <ExclamationTriangleIcon class="mt-0.5 size-5 shrink-0" aria-hidden="true" />
      <p>{{ warning }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid';

const props = defineProps<{
  id: string;
  label: string;
  description: string;
  modelValue: boolean;
  disabled?: boolean;
  warning?: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const describedBy = computed(() =>
  [`${props.id}-desc`, props.warning ? `${props.id}-warning` : ''].filter(Boolean).join(' ')
);
</script>
